/**
 * @Desription: 方法-地址管理
 * @Author: netstar.sjj
 * @Date: 2021-10-26 16:05:00
 * @names: urlManager
*/
declare const window:any;
namespace urlManager{
    /**
     * 根据入参url解析返回url后边的参数对象
     * @param  {string} urlStr 当前url地址
     * @returns object 返回参
    */
    export function getUrlPara(urlStr?:string) {
        urlStr = typeof(urlStr)=='string' ? urlStr : '';
        if (urlStr == '') {
            urlStr = document.location.toString();
        }
        let paraStr:string = urlStr.substr(urlStr.indexOf('?') + 1);
        let paraArr:any = paraStr.split('&');
        let paraObj:any = {};
        for (let paraI = 0; paraI < paraArr.length; paraI++) {
            let equalIndex = paraArr[paraI].indexOf('=');
            let paraName = paraArr[paraI].substr(0, equalIndex);
            let paraValue = paraArr[paraI].substr(equalIndex + 1);
            paraObj[paraName] = paraValue;
        }
        if(paraObj.nsserver){
            let lastChar = paraObj.nsserver.substr(paraObj.nsserver.length - 1);
            //常出现的错误输入 1. 缺少'/'，2.多了个'#'
            if (lastChar == '#') {
                paraObj.nsserver = paraObj.nsserver.substr(0, paraObj.nsserver.length - 1);
                lastChar = paraObj.nsserver.substr(paraObj.nsserver.length - 1);
            }
            if (lastChar != '/') {
                paraObj.nsserver = paraObj.nsserver + '/';
            }
        }
        return paraObj;
    }
    /**
     * 获取api地址
     */
    export function getAPIUrl(){
        let apiUrlStr:string = '';
        let urlParaObj:any = window.NSUtils.getUrlPara();
        if(urlParaObj.nsserver){
            apiUrlStr = urlParaObj.nsserver;
        }else if(window.NetstarApiConfig.path){
            apiUrlStr = window.NetstarApiConfig.path;
        }
        return apiUrlStr;
    }
    /**
     * 获取web地址
     */
    export function getWebUrl(){
        let webUrlStr:string = '';
        if(window.NetstarApiConfig.webRootPath){
            webUrlStr = window.NetstarApiConfig.webRootPath;
        }else{
            webUrlStr = window.document.location.origin + '/web/';
        }
        return webUrlStr;
    }
    /**
     * 根据指定的url地址输出完整的访问路径
     * @param  {any} obj
     */
    export function getUrl(innerUrl?:string){
        let returnUrl:string = '';
        let urlObj:any = {};
        let urlParaObj:any = window.NSUtils.getUrlPara();
        if(typeof (innerUrl) == 'string') {
            //当前入参是一个url地址 需要根据当前是否包含http判断是否是一个完整的路径
            urlObj = {suffix:innerUrl};
            if(innerUrl.indexOf('http')===-1){
                urlObj.urlType = 'api';
            }else{
                urlObj.urlType = 'http';
            }
        }else if(typeof(innerUrl)=='object'){
            urlObj = innerUrl;
            if(urlObj.suffix){
                if(urlObj.suffix.indexOf('http')>-1){
                    urlObj.urlType = 'http';
                }
            }
        }

        if(typeof(urlObj.suffix)=='undefined'){
            if(urlParaObj.nsserver){
                return urlParaObj.nsserver;
            }else if(window.NetstarApiConfig.path){
                return window.NetstarApiConfig.path;
            }
            return window.NetstarApiConfig.path;
        }
        let urlTypeStr:string = urlObj.urlType ? urlObj.urlType : 'api';
        if(urlObj.suffix.indexOf('/') === 0){
            urlObj.suffix = urlObj.suffix.substr(1,urlObj.suffix.length);
        }
        let suffix = urlObj.suffix;
        switch(urlTypeStr){
            case 'http':
            case 'https':
                //完整的路径
                returnUrl = urlObj.suffix;
                break;
            case 'templateEditor':
                // 用于编辑器 获取/保存 pageConfig
                if(urlParaObj.nseditorserver){
                    returnUrl = urlParaObj.nseditorserver + urlObj.suffix;
                }else if(typeof(window.NetstarApiConfig) == "object" && window.NetstarApiConfig.nsEditorServer){
                    returnUrl = window.NetstarApiConfig.nsEditorServer + urlObj.suffix;
                }else if(urlParaObj.nsserver){
                    returnUrl = urlParaObj.nsserver+urlObj.suffix;
                }else if(window.NetstarApiConfig.path){
                    returnUrl = window.NetstarApiConfig.path +urlObj.suffix;
                }else{
                    console.warn(urlObj);
                }
                break;
            case 'api':
            case 'midware':
                //后台接口默认 path
                if(urlParaObj.nsserver){
                    returnUrl = urlParaObj.nsserver+urlObj.suffix;
                }else if(window.NetstarApiConfig.path){
                    returnUrl = window.NetstarApiConfig.path +urlObj.suffix;
                }else{
                    console.warn(urlObj);
                }
                break;
            case 'web':
                //前台路径 （页面）webRootPath
                if(window.NetstarApiConfig.webRootPath){
                    let temp1:string = window.NetstarApiConfig.webRootPath.split('/');
                    let temp2:string = urlObj.suffix.split('/');
                    if(temp1[temp1.length-2] === temp2[0]){
                        returnUrl = window.NetstarApiConfig.webRootPath + urlObj.suffix.substr(urlObj.suffix.indexOf('/')+1);
                    }else{
                        returnUrl = window.NetstarApiConfig.webRootPath+urlObj.suffix;
                    }
                }else{
                    if(urlObj.suffix.split('/')[0] === 'web'){
                        returnUrl = window.document.location.origin + '/'+urlObj.suffix;
                    }else{
                        returnUrl = window.document.location.origin + '/web/'+urlObj.suffix;
                    }
                }
                break;
            case 'server':
                //服务器端后台接口 serverRootPath
                if(window.NetstarApiConfig.serverRootPath){
                    returnUrl = window.NetstarApiConfig.serverRootPath +urlObj.suffix;
                }
                break;
            case 'middleware':
                //旧中台 middlewareRootPath
                if(urlParaObj.nsmidwareserver){
                    returnUrl = urlParaObj.nsmidwareserver+urlObj.suffix;
                }else if(window.NetstarApiConfig.middlewareRootPath){
                    returnUrl = window.NetstarApiConfig.middlewareRootPath+urlObj.suffix;
                }
                break;
            case 'apiEngineEditor':
                // 方法序列编辑器
                returnUrl = window.NetstarApiConfig.apiEngineEditor + urlObj.suffix;
                break;
            case 'apiEngine':
                let prefix = "";
                if(window.NetstarApiConfig.apiEngine){
                    prefix = window.NetstarApiConfig.apiEngine;
                }else if(urlParaObj.apiEngine){
                    prefix = urlParaObj.apiEngine;
                }
                //如果最后一个字符是'/' 则删除
                var lastCharacter = prefix.substr(prefix.length - 1);
                if (lastCharacter == '/') {
                    prefix = prefix.substr(0, prefix.length - 1)
                }
                //如果第一个字符是 '/' 也删除
                var firstCharacter = suffix.substr(0, 1);
                if (firstCharacter == '/') {
                    suffix = suffix.substr(1, suffix.length)
                }
                //整理后重新拼接
                returnUrl = prefix + '/' + suffix;
                break;
            case "gatewayApi":
                if(typeof(window.NetstarApiConfig) == "object" && window.NetstarApiConfig.gatewayPath){
                    prefix = window.NetstarApiConfig.gatewayPath;
                }else if(typeof(window.NetstarApiConfig) == "object" && (window.NetstarApiConfig.apiRootPath || window.NetstarApiConfig.path)) {
                    if (window.NetstarApiConfig.apiRootPath) {
                        prefix = window.NetstarApiConfig.apiRootPath;
                    } else {
                        prefix = window.NetstarApiConfig.path;
                    }
                } else {
                    prefix = getAPIUrl();
                }
                //如果最后一个字符是'/' 则删除
                var lastCharacter = prefix.substr(prefix.length - 1);
                if (lastCharacter == '/') {
                    prefix = prefix.substr(0, prefix.length - 1)
                }
                //如果第一个字符是 '/' 也删除
                var firstCharacter = suffix.substr(0, 1);
                if (firstCharacter == '/') {
                    suffix = suffix.substr(1, suffix.length)
                }
                //整理后重新拼接
                returnUrl = prefix + '/' + suffix;
                break;
            default:
                break;
        }
        return returnUrl;
    }
    export namespace resetServerUrl{
        export function get(){
            //如果没有修改过则返回false
            let url:any = false;
            let resetInfo:any = window.store.get('NetstarResetServerInfo');
            if (typeof (resetInfo) == 'object') {
                if (resetInfo.isReset) {
                    url = resetInfo.url;
                }
            }
            return url;
        }
        export function reset(_serverRootPath?:string){
            // 替换默认路径
            if (typeof (window.NetstarApiConfig) == 'object' && typeof (window.NetstarApiConfig.path) == 'string') {
                _serverRootPath = window.NetstarApiConfig.path;
                window.serverRootPath = _serverRootPath;
            }
            _serverRootPath = typeof(_serverRootPath)=='string' ? _serverRootPath : '';
            if(_serverRootPath == ''){
                window.nsalert('服务器端API地址为空','error');
                return;
            }
            let urlParas:any = window.NSUtils.getUrlPara();
            let isReset:boolean = false;
            if (typeof (urlParas) == 'object') {
                if (typeof (urlParas.nsserver) == 'string') {
                    _serverRootPath = urlParas.nsserver;
                    let lastChar:string = _serverRootPath.substr(_serverRootPath.length - 1);
                    //常出现的错误输入 1. 缺少'/'，2.多了个'#'
                    if (lastChar == '#') {
                        _serverRootPath = _serverRootPath.substr(0, _serverRootPath.length - 1);
                        lastChar = _serverRootPath.substr(_serverRootPath.length - 1);
                    }
                    if (lastChar != '/') {
                        _serverRootPath = _serverRootPath + '/';
                    }
                    isReset = true;
                    console.warn('服务器端API地址已修改为：' + _serverRootPath);
                }
            }
            let resetInfo:any = {
                url: _serverRootPath, 	//修改后的url
                isReset: isReset, 		//是否修改
            }
            window.store.set('NetstarResetServerInfo', resetInfo);
            return _serverRootPath;
        }
    }
    export function wrapUrl(urlPath?:string){
        const appendAuth:Function = function() {
            let auth:string = 'Authorization=' + window.NSUtils.OAuthCode.get();
            if (urlPath.indexOf('?') > 0) {
                urlPath += '&';
            } else {
                urlPath += '?';
            }
            urlPath += auth;
        }
        if(!urlPath) {
            window.nsalert('错误的地址:' + urlPath);
            return urlPath;
        }
        let origin:string = location.origin;
        if (urlPath.startsWith(origin)) {
            return urlPath;
        }
        if (urlPath.startsWith('http')) {
            appendAuth();
            return urlPath;
        }
        let base = window.NSUtils.getAPIUrl();
        if (!base.endsWith('/')) {
            base = base + '/';
        }
        if (urlPath.startsWith('/')) {
            urlPath = urlPath.substr(1);
        }
        if (!base.startsWith(origin)) {
            appendAuth();
        }
        return base + urlPath;
    }
}
export default urlManager;